import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import WorkWithMN from "../pages/WorkWithMN";
import Courses from "../pages/Courses";
import Read from "../pages/Read";
import GetInTouch from "../pages/GetInTouch";
import MainPage from "../pages/MainPage";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import MyPersonalStory from "../components/MyPersonalStory";
import Carosel from "../components/Carosel";
import Brands from "../unused/Brands";
import OurCourses from "../pages/OurCourses";
import NotFound from "../pages/NotFound";
import BackToTopButton from "../components/BackToTopButton";
import CourseDetail from "../pages/CourseDetail";
import IndividualNutrition from "../components/IndividualNutrition";
import Philosopy from "../components/Philosopy";
import SportsNutrition from "../components/SportsNutrition";
import CorporateNutrition from "../components/CorporateNutrition";
import CorporateNutritionPage from "../pages/CorporateNutritionPage";
import ScrollToTop from "../components/organisms/ScrollToTop";

export default function BasicPageTem() {
  return (
    <>
      <div>
        <Router>
          <Navbar />
          {/* <ScrollToTop /> */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="about" element={<About />}>
              <Route path="personal-story" element={<MyPersonalStory />} />
              <Route path="team" element={<Carosel />} />
              <Route path="partners" element={<Brands />} />
            </Route>
            <Route path="work-with-mn" element={<WorkWithMN />}>
              <Route
                path="individual-nutrition"
                element={<IndividualNutrition />}
              />
              <Route path="philosopy" element={<Philosopy />} />
              <Route path="sports-nutrition" element={<SportsNutrition />} />
              <Route
                path="corporate-nutrition"
                element={<CorporateNutrition />}
              />
            </Route>
            <Route
              path="corporate-nutrition"
              element={<CorporateNutritionPage />}
            />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/our-courses" element={<OurCourses />} />
            <Route
              path="/courses/our-courses/:courseName"
              element={<CourseDetail />}
            />
            {/* <Route path="read" element={<Read />} /> */}
            <Route path="get-in-touch" element={<GetInTouch />} />
            <Route path="main" element={<MainPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>

        {<BackToTopButton />}
        <Footer />
      </div>
    </>
  );
}
